import React, { createContext, useContext, useMemo, useState } from 'react';

const RegionContext = createContext();

export function RegionProvider({ children }) {
    const [region, setRegion] = useState(null);
    const [regionData, setRegionData] = useState(null);

    const clearRegion = () => {
        setRegion(null);
        setRegionData(null);
    };
    const providerParams = useMemo(() => {
        return {
            region,
            setRegion,
            clearRegion,
            regionData,
            setRegionData
        };
    }, [region, regionData]);

    return <RegionContext.Provider value={providerParams}>{children}</RegionContext.Provider>;
}

export const useRegionContext = () => {
    const context = useContext(RegionContext);
    if (context === undefined) {
        throw new Error('useRegionContext must be used within a RegionProvider');
    }
    return context;
};
